
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./momo-payment.cjs.production.min.js')
} else {
  module.exports = require('./momo-payment.cjs.development.js')
}
